"use client";
import type { ICommonAppData } from "@/lib/types/sanity";
import dynamic from "next/dynamic";


const DAdnuntiusAd = dynamic(() =>
    import('@/components/framework/AdnuntiusAd').then((mod) => mod.default),
    { ssr: false }
);

//#region [Props]
type DynamicAdnuntiusAdProps = {
    appData: ICommonAppData,
    index: number,
    className?: string;
    hideOnMobile: boolean;
    hideOnDesktop?: boolean;
    debugLabel?: string;
    showAdAfterFirstScroll?: boolean;
};
//#endregion

//#region [Component]
export default function DynamicAdnuntiusAd(props: DynamicAdnuntiusAdProps) {
    return <DAdnuntiusAd {...props} />;
}
//#endregion